import { render, staticRenderFns } from "./ChecktestQuestionForm.vue?vue&type=template&id=48caf7f1&"
import script from "./ChecktestQuestionForm.vue?vue&type=script&lang=ts&"
export * from "./ChecktestQuestionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChecktestQuestionForm.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports